import React from "react";
import "./CheckBox.scss";
import cn from "classnames";

interface CheckBoxProps {
  checked: boolean;
  label: string;
  onCheck: (key: string, value: boolean) => void;
  className?: string;
  type?: "checkbox" | "radio";
  disabled?: boolean;
  [passthroughProp: string]: any;
}

const CheckBox: React.FC<CheckBoxProps> = React.memo(
  ({
    checked,
    label,
    onCheck,
    className: providedClassName,
    type = "checkbox",
    disabled = false,
    ...passthrough
  }) => {
    return (
      <div className={cn("checkBoxContainer", providedClassName, { radio: type === "radio" })}>
        <div
          className={cn("checkBox", { checked: checked, disabled: disabled })}
          onClick={() => {
            if (!disabled) {
              onCheck(label, !checked);
            }
          }}
          {...passthrough}
        ></div>
        <div className={cn("label", { checked: checked, disabled: disabled })}>{label}</div>
      </div>
    );
  }
);

export default CheckBox;
